import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DictionaryKeyEnum } from '@core/enums/dictionary-key.enum';
import { DictionaryModel, DictionaryResponseModel, DictionarySet } from '@core/models/dictionary.model';
import { Observable } from 'rxjs';
import { DomainService } from '../domain.service';

@Injectable({
  providedIn: 'root'
})
export class DictionaryNativeService {
  private _apiUrl: string = '';

  constructor(private readonly http: HttpClient,
    private _domainService: DomainService,
  ) {
    this._domainService.apiUrl$.subscribe((apiUrl: string) => {
      this._apiUrl = apiUrl;
    });
  }

  getDictionaryByKey(params: { key: DictionaryKeyEnum }): Observable<DictionaryResponseModel> {
    return this.http.get<DictionaryResponseModel>(`${this._apiUrl}dispatcher/dictionary/key/${params.key}?format=json`);
  }

  mapDictionaryById(dictionaryList: DictionaryModel[]): DictionarySet {
    const dictionaryMap = dictionaryList.reduce<Record<number, DictionaryModel>>((dictionaryMap, item) => {
      dictionaryMap[item.Id] = item;
      return dictionaryMap;
    }, {});

    return dictionaryMap;
  }
}
